import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const Accordion = ({ icon, title, children, defaultOpen = false, variant = "card" }) => {
  const [open, setOpen] = useState(defaultOpen);
  const isPlain = variant === "plain";

  return (
    <div
      className={
        isPlain
          ? "border-b-[1.5px] border-violet-300/[0.35]"
          : "rounded-2xl overflow-hidden bg-white/[0.92] border border-pink-200 shadow-accordion"
      }
    >
      <button
        onClick={() => setOpen((o) => !o)}
        className={`w-full flex items-center justify-between gap-3 text-left active:scale-[0.99] transition-transform ${
          isPlain
            ? "py-3 text-brand-dark font-semibold text-sm"
            : "px-5 py-4 text-brand-primary font-bold text-base"
        }`}
      >
        <span className="flex items-center gap-2">
          {icon && <span>{icon}</span>}
          <span>{title}</span>
        </span>
        <ChevronDown
          size={isPlain ? 16 : 20}
          strokeWidth={2.5}
          className={`flex-shrink-0 transition-transform duration-300 ${
            isPlain ? "text-brand-muted" : "text-brand-primary"
          } ${open ? "rotate-180" : "rotate-0"}`}
        />
      </button>
      <div
        className={`grid transition-[grid-template-rows] duration-[0.35s] ease-in-out ${
          open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
        }`}
      >
        <div className="overflow-hidden">
          <div
            className={
              isPlain
                ? "pb-3 text-sm leading-relaxed text-left text-gray-500"
                : "px-5 pb-5 text-sm leading-relaxed text-left text-gray-500"
            }
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
